/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiRoomFromJSON, StreemApiRoomToJSON, } from './';
export function StreemApiEventsRoomArchivedFromJSON(json) {
    return StreemApiEventsRoomArchivedFromJSONTyped(json, false);
}
export function StreemApiEventsRoomArchivedFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'room': !exists(json, 'room') ? undefined : StreemApiRoomFromJSON(json['room']),
        'archivedAt': !exists(json, 'archived_at') ? undefined : (new Date(json['archived_at'])),
        'archiveS3FolderPath': !exists(json, 'archive_s3_folder_path') ? undefined : json['archive_s3_folder_path'],
        'recordingArtifactId': !exists(json, 'recording_artifact_id') ? undefined : json['recording_artifact_id'],
    };
}
export function StreemApiEventsRoomArchivedToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'room': StreemApiRoomToJSON(value.room),
        'archived_at': value.archivedAt === undefined ? undefined : (value.archivedAt.toISOString()),
        'archive_s3_folder_path': value.archiveS3FolderPath,
        'recording_artifact_id': value.recordingArtifactId,
    };
}
//# sourceMappingURL=StreemApiEventsRoomArchived.js.map